import { BackIcon } from 'assets/icons';
import SectionHeader from 'components/layout/SectionHeader';
import { PrimaryBtn } from 'components/UI/Buttons';
import PageTitle from 'components/UI/PageTitle';
import PaperContainer from 'components/UI/PaperContainer';
import { useNavigate } from 'react-router-dom';

const Unauthorized = () => {
  const navigate = useNavigate();
  return (
    <>
      <SectionHeader text="Error 401" button={null} />
      <PaperContainer>
        <PageTitle sx={{ mb: 2 }}>Oops... Parece que no tienes permisos para acceder a esta página</PageTitle>
        <img
          src="https://64.media.tumblr.com/e27cb0108080a13a7618a34d4492aae8/tumblr_om3wzrm1ou1rn5gv3o1_500.gif"
          alt="success gif"
          width="300px"
        />
        <PrimaryBtn
          onClick={() => navigate('/clients')}
          sx={{ mt: 6, width: '200px' }}
          startIcon={<BackIcon />}
          variant="contained"
        >
          Volver al Inicio
        </PrimaryBtn>
      </PaperContainer>
    </>
  );
};

export default Unauthorized;
